<div *ngIf="descriptor">

    <vedrax-table-filter [filters]="descriptor.filters" (onSubmit)="filter($event)" [submitted]="submitted">
    </vedrax-table-filter>

    <div class="vedrax-table-export-button">
        <button mat-raised-button color="primary" (click)="exporter.exportTable('xlsx')">
            XLSX
        </button>
        <button mat-raised-button color="primary" (click)="exporter.exportTable('csv')">
            CSV
        </button>
    </div>

    <div class="table-responsive vedrax-table-m-t-15 vedrax-table-box mat-elevation-z8">
        <table matTableExporter #exporter="matTableExporter" mat-table [dataSource]="datasource">
            <ng-container *ngFor="let col of descriptor.columns" [matColumnDef]="col.id">
                <th mat-header-cell *matHeaderCellDef> {{col.label}} </th>
                <td mat-cell *matCellDef="let element">
                    <div *ngIf="col.actions as navigations; else dataContent">

                        <button mat-icon-button [matMenuTriggerFor]="actionMenu" aria-label="action menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionMenu="matMenu">
                            <ng-container *ngFor="let action of navigations">
                                <a *ngIf="isActionEnable(action, element)" mat-menu-item
                                    (click)="select(action, element)">{{action.label}}</a>
                            </ng-container>
                        </mat-menu>

                    </div>
                    <ng-template #dataContent>
                        {{element[col.id]}}
                    </ng-template>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator *ngIf="descriptor.paginated" [length]="totalLength" [pageSize]="30">
        </mat-paginator>
    </div>

</div>